import { render } from "./MessageComponent.vue?vue&type=template&id=3b7da50a"
import script from "./MessageComponent.vue?vue&type=script&lang=js"
export * from "./MessageComponent.vue?vue&type=script&lang=js"

import "./MessageComponent.vue?vue&type=style&index=0&id=3b7da50a&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__